import dragula from 'dragula'
import xhrModule from './xhrModule.js'
import calculateOffsets from './calculateOffsets.js'

var sortable = function (options) {
	return {
		init: function () {
			this.type = options.type
			this.callback = options.callback
			this.saveStructureCallback = options.saveStructureCallback
			this.entityID = options.entityID
			this.form = options.form
			this.nestable = options.nestable
			this.collapsible = options.collapsible
			this.postData = false
			var containers = null
			this.container = null
			if (options.container) {
				this.container = options.container
				containers = [options.container]
			} else {
				this.postData = true
				this.container = document.querySelectorAll('.draggable-container')
				containers = Array.prototype.slice.call(this.container)
			}

			var dragulaOptions = {
				containers: containers,
				moves: function (el, container, handle) {
					var bool = false
					if (handle.classList.contains('handle') || handle.classList.contains('grip')) {
						bool = true
					}
					return bool
				},
				accepts: function (el, target, source) {
					return !el.contains(target)
				}
			}

			this.drake = dragula(dragulaOptions)
			this.drake.on('dragend', this.dragendHandler.bind(this))

			if (this.nestable === 'true') {
				this.drake.on('drop', this.dropHandler.bind(this))
			}
		},

		dragendHandler: function (item) {
			if (!this.form) {
				if (this.type === 'languages') {
					this.callback()
				} else {
					var itemContainer = item.closest('ul.data-view')
					// overview list for instances
					if (this.postData) {
						var options = {
							callback: this.offsetsCalculated.bind(this),
							container: itemContainer
						}
						// recalculate fieldsTree
						calculateOffsets.init(options)

						if (this.saveStructureCallback) {
							// save page instance with updated structure group
							this.saveStructureCallback(item)
						}
					} else {
						// overview of editable references
						var items1 = document.querySelectorAll('.multiple-references .draggable-item')
						for (var k = 0; k < items1.length; k++) {
							var searchAllInputElementsWithName = items1[k].querySelectorAll('[name]')
							for (var o = searchAllInputElementsWithName.length - 1; o >= 0; o--) {
								var name = searchAllInputElementsWithName[o].getAttribute('name')
								var splitName = name.split('.')
								splitName[1] = (k + 1).toString()
								var newName = splitName.toString()
								var newStr = newName.replace(/,/g, '.')

								searchAllInputElementsWithName[o].setAttribute('name', newStr)

								// set element back to checked in case it lost its value
								if (searchAllInputElementsWithName[o].getAttribute('checked') === '') {
									searchAllInputElementsWithName[o].checked = true
								}
							}
						}
					}
				}
			} else {
				this.callback()
			}
		},

		offsetsCalculated: function (childrenTreeArr) {
			// change key ID to UUID
			for (var i = childrenTreeArr.length - 1; i >= 0; i--) {
				childrenTreeArr[i]['uuid'] = childrenTreeArr[i]['id']
				delete childrenTreeArr[i]['id']

				if (i === 0) {
					var sort = {
						'entity': this.entityID,
						'instances': childrenTreeArr
					}

					this.newOffsets = childrenTreeArr

					var json = JSON.stringify(sort)
					var url = '/cms/api/instances/sort'
					xhrModule.post(url, json, this.sortCompleted.bind(this))
				}
			}
		},

		dropHandler: function (el, target, source, sibling) {
			if (this.collapsible == true) {
				// check if the dropped item has onther draggable item as parent
				var parent = target.parentNode
				if (parent.classList.contains('draggable-item')) {
					parent.classList.add('draggable-collapsable')
				}

				// if the source is empty and also has a draggable item as parent we can remove the draggable-collapsable class
				var sourceParent = source.parentNode
				var sourceChilds = source.querySelectorAll('li')
				if (sourceParent.classList.contains('draggable-item') && sourceChilds.length === 0) {
					sourceParent.classList.remove('draggable-collapsable')
				}
			}
		},

		sortCompleted: function (data) {
			// console.log('sort complete: ', data)
			this.callback(this.newOffsets)
		},

		destroy: function () {
			this.drake.destroy()
		}
	}
}

export default sortable
